import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["dialog", "message", "confirmButton"]

  connect() {
    this.setupTurboConfirm()
  }

  setupTurboConfirm() {
    Turbo.config.forms.confirm = (message, element, submitter) => {
      if (!this.hasDialogTarget) {
        return Promise.resolve(confirm(message))
      }

      this.messageTarget.innerHTML = message

      const buttonText = submitter?.dataset.turboConfirmButton || "Confirmar"
      const buttonClass = submitter?.dataset.turboConfirmButtonClass || "btn-error"

      this.confirmButtonTarget.innerHTML = buttonText
      this.confirmButtonTarget.className = ["btn", ...buttonClass.split(/\s+/).filter((className) => className && className !== "btn")].join(" ")

      this.dialogTarget.showModal()

      return new Promise((resolve) => {
        this.dialogTarget.addEventListener("close", () => {
          resolve(this.dialogTarget.returnValue === "confirm")
        }, { once: true })
      })
    }
  }

  cancel() {
    this.dialogTarget.close("cancel")
  }
}
